// extracted by mini-css-extract-plugin
export default {"melodyVideo":"rK-z","isFullWidth":"sK-z","landingPageVideo":"tK-z","play":"uK-z","iframeVideo":"vK-z","playHidden":"wK-z","fullwidth":"xK-z"};